import styled from 'styled-components';

const Text = styled.p`
  font-family: 'Menlo';
  font-size: 24px;
  text-align: center;
`;

export { Text };


// WEBPACK FOOTER //
// ./src/components/UI/Text.jsx